module.exports = __webpack_public_path__ + "img/bronze.896d3f9c.png";